import React from 'react';
import {BasicForm} from "./BasicForm";

export class ApplicationForm extends React.Component {

  render(){
    return (
      <BasicForm formId={3}/>
    );
  }
}




// WEBPACK FOOTER //
// ./src/forms/ApplicationForm.js